import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectHasRampFilter } from 'shared/selectors/advancedFilters/accessibleEnvironment';
import { CustomCheckbox } from 'shared/components/CustomCheckbox';

export const HasRampContainer: FC = () => {
  const { label, value } = useSelector(selectHasRampFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange({ action: 'setHasRamp', arguments: [value || null] });
    },
    [onChange],
  );

  return <CustomCheckbox label={label} checked={value} onChange={handleChange} />;
};
